import React from 'react';
import Icon from '../../../components/AppIcon';

const SecurityIndicators = () => {
  const securityFeatures = [
    {
      icon: 'Shield',
      title: 'SSL Encrypted',
      description: '256-bit encryption protects your data'
    },
    {
      icon: 'Lock',
      title: 'Secure Authentication',
      description: 'Industry-standard security protocols'
    },
    {
      icon: 'Database',
      title: 'Data Protection',
      description: 'GDPR & CCPA compliant storage'
    }
  ];

  return (
    <div className="space-y-4">
      <div className="flex items-center space-x-2 text-success">
        <Icon name="CheckCircle" size={20} />
        <span className="text-sm font-medium">Secure Connection Active</span>
      </div>
      <div className="grid grid-cols-1 gap-3">
        {securityFeatures?.map((feature, index) => (
          <div
            key={index}
            className="flex items-start space-x-3 p-3 bg-muted/50 rounded-lg border border-border"
          >
            <div className="flex-shrink-0 w-10 h-10 bg-primary/10 rounded-lg flex items-center justify-center">
              <Icon name={feature?.icon} size={20} color="var(--color-primary)" />
            </div>
            <div className="flex-1 min-w-0">
              <h4 className="text-sm font-medium text-foreground mb-1">
                {feature?.title}
              </h4>
              <p className="text-xs text-muted-foreground">
                {feature?.description}
              </p>
            </div>
          </div>
        ))}
      </div>
      <div className="pt-4 border-t border-border">
        <p className="text-xs text-muted-foreground text-center">
          Your privacy is our priority. We never share your personal information with third parties.
        </p>
      </div>
    </div>
  );
};

export default SecurityIndicators;